(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/templates/tickets/assets/javascripts/cookie-monster.js') >= 0) return;  svs.modules.push('/templates/tickets/assets/javascripts/cookie-monster.js');
"use strict";


if (svs.core.detect.feature('ft-lotter-cookie-monster')) {
  const logger = svs.core.log.getLogger('template_tickets:cookie-monster');
  const cookieMonster = async () => {
    if (!cookieStore) {
      logger.warn('Cookie Monster might be hungry but cookieStore is not available');
      return;
    }
    logger.info('Cookie Monster is looking for cookies');
    const cookies = await cookieStore.getAll();
    if ((cookies === null || cookies === void 0 ? void 0 : cookies.length) >= 38) {
      logger.warn("Cookie Monster is hungry and found ".concat(cookies.length, " cookies!"));
      const mouth = [];
      const gaCookies = cookies.filter(cookie => {
        var _cookie$name, _cookie$name$startsWi;
        return (_cookie$name = cookie.name) === null || _cookie$name === void 0 || (_cookie$name$startsWi = _cookie$name.startsWith) === null || _cookie$name$startsWi === void 0 ? void 0 : _cookie$name$startsWi.call(_cookie$name, '_ga');
      });
      if (gaCookies.length > 2) {
        mouth.push(...gaCookies.map(cookie => cookie.name));
      }
      const hjCookies = cookies.filter(cookie => {
        var _cookie$name2, _cookie$name2$startsW;
        return (_cookie$name2 = cookie.name) === null || _cookie$name2 === void 0 || (_cookie$name2$startsW = _cookie$name2.startsWith) === null || _cookie$name2$startsW === void 0 ? void 0 : _cookie$name2$startsW.call(_cookie$name2, '_hj');
      });
      if (hjCookies.length > 2) {
        mouth.push(...hjCookies.map(cookie => cookie.name));
      }
      logger.info("Cookie Monster is eating ".concat(mouth.length, " cookies: ").concat(mouth.join(', ')));
      mouth.forEach(cookieName => {
        cookieStore.delete(cookieName);
      });
      const remainingCookies = await cookieStore.getAll();
      logger.info("Cookie Monster is full and left ".concat(remainingCookies.length, " cookies"));
      if (remainingCookies.length !== cookies.length - mouth.length) {
        logger.info("Cookie Monster was unable to eat ".concat(remainingCookies.length - (cookies.length - mouth.length), " cookies"));
      }
    } else {
      logger.info("Cookie Monster found ".concat(cookies.length, " cookies but is not hungry"));
    }
  };
  cookieMonster();
}

 })(window);